import React from "react";

const Portfolio = () => {
  const portfolioItems = [
    {
      title: "ktccruises.com",
      url: "https://ktccruises.com/",
      img: "img/portfolio/ktccruises.png",
      tech: "Cruise Booking Portal",
    },
    {
      title: "resai.co",
      url: "https://resai.co/",
      img: "img/portfolio/resai.png",
      tech: "AI Resume Builder SaaS",
    },
    {
      title: "bcfares.com",
      url: "https://bcfares.com/",
      img: "img/portfolio/bcfares.png",
      tech: "Business Class Flights Portal",
    },
    {
      title: "standardelectricals.vercel.app",
      url: "https://standardelectricals.vercel.app/",
      img: "img/portfolio/standard-electricals.png",
      tech: "Website using HTML",
    },
    {
      title: "mvc-two-vert.vercel.app",
      url: "https://mvc-two-vert.vercel.app/",
      img: "img/portfolio/Microvision-Developers.png",
      tech: "Website using PHP",
    },
    {
      title: "microvisioninfotech.com",
      url: "http://microvisioninfotech.com",
      img: "img/portfolio/microvision-infotech.png",
      tech: "Website using React",
    },
  ];

  return (
    <>
      <style>{`
        #portfolio {
          scroll-margin-top: 140px !important;
          padding: 100px 0 60px 0 !important;
        }
        #portfolio .section-header {
          margin-bottom: 40px;
        }
        #portfolio .portfolio-item {
          margin-bottom: 30px;
        }
        #portfolio .portfolio-item .portfolio-wrap {
          border-radius: 10px;
          overflow: hidden;
          background: #111;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
          transition: all 0.4s ease;
        }
        #portfolio .portfolio-item .portfolio-wrap:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(0, 123, 255, 0.3);
        }
        #portfolio .portfolio-item .portfolio-img {
          width: 100%;
          height: 240px;
          overflow: hidden;
          background: #1a2436;
        }
        #portfolio .portfolio-item .portfolio-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top center;
          transition: transform 0.5s ease;
        }
        #portfolio .portfolio-item:hover .portfolio-img img {
          transform: scale(1.08);
        }
      `}</style>
      <section id="portfolio" className="clearfix">
        <div className="container">
          <header className="section-header">
            <h3 className="section-title">Our Portfolio</h3>
            <p>
              Explore a selection of our featured web applications, AI portals, and digital platforms built for client success.
            </p>
          </header>

          <div className="row portfolio-container">
            {portfolioItems.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6 portfolio-item">
                <div className="portfolio-wrap">
                  <div className="portfolio-img">
                    <img
                      src={item.img}
                      className="img-fluid"
                      alt={item.title}
                    />
                  </div>
                  <div className="portfolio-info">
                    <h4>
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.title}
                      </a>
                    </h4>
                    <p>{item.tech}</p>
                    <div>
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link-details"
                        title="Visit Website"
                      >
                        <i className="ion ion-android-open"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Portfolio;